module.exports = __webpack_public_path__ + "static/media/ascension-logo.5f00cf79.png";